import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from "../utils/apiClient";
import '../style/LogoGalley.css';

const Logos = () => {
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    const getMarcas = async () => {
      try {
        const res = await api.get("marcasymodelos/marcaCantidad");
        setLogos(res.data);
      } catch (error) {
        console.error('Error fetching marcas:', error);
      }
    };
    getMarcas();
  }, []);

  const largeLogos = ['Dodge', 'Mercedes Benz', 'Hyundai', 'GMC'];

  const isLarge = (nombre) => largeLogos.includes(nombre);

  return (
    <div className="logos-container">
      <h3 className="logos-title">Marcas disponibles</h3>
      <div className="logos-grid">
      {logos.map((logo, index) => {
        const large = isLarge(logo.Nombre);
        return (
          <Link
            key={index}
            to={`/stock?marca=${logo.Nombre}`}
            className={`logo-reference${large ? ' logo-reference--large' : ''}`}
          >
            <div className={large ? 'large-logo-container' : 'square-logo-container'}>
              <img
                src={logo.Imagen}
                alt={logo.Nombre}
                className={large ? 'large-logo' : 'square-logo'}
              />
            </div>
            <span className="logo-count">{logo.cantidad}</span>
          </Link>
        );
      })}
      </div>
    </div>
  );
};

export default Logos;
